// ========= plugin import =========== //
import React,{useEffect, useState} from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import { useParams, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
// =========== module import ========== //
import { PageTitle } from "../../../../_template/layout/core/PageData";
import { MenuComponent } from '../../../../_template/assets/ts/components/MenuComponent';
import { specialCharacterValidate } from '../../../component/common/Helper';
// =========== component import ============= //
import Step1 from './component/step/step1/Step1';
import Step2 from './component/step/step2/Step2';
import Step3 from './component/step/step3/Step3';
import Step4 from './component/step/step4/Step4';
import Step5 from './component/step/step5/Step5';
import ButtonLoader from '../../../component/common/ButtonLoader';

const ManageVirtualAgent = () => {
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;
    const { param_bot_id } = useParams();
    const navigate = useNavigate();

    const pageTitle = [
        {
            title: 'Agent',
            path: loginUserType === 'A' ? '/virtual-agent/agents' : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const [formData, setFormData] = useState({
        bot_id : '',
        old_bot_name: '',
        step1: {
            bot_name: '', 
            channel_name: null,
            language: null,
            bot_description: '',
            bot_avtar: null,
            brand_icon: null,
            widget_type: '',
            widget_url: '',
            hook_url: '',
        },
        step2: {
            others_form_setup : [],
        },
        step3: {
            product_setup :[],
            features_setup : [],
            product_features_association: {},
            product_features_association_data: [],
        },
        step4: {
            service_setup : [],
            attribute_setup : [],
            service_attributes_association : {},
            service_attributes_association_setup: []
        },
        step5: {
            final_form_setup : [],
            bot_color_type : 'gradient_color',
            bot_color : 'linear-gradient(red, yellow, green)'
        }
    });
    const [previousFile, setPreviousFile] = useState({
        bot_avatar_file: {},
        brand_icon: {}
    });

    const validateStep = (step, data = formData[step]) => {
        const errors = {};
        // return errors;
        if (step === 'step1') {
            if (!data.bot_name || data.bot_name.trim() === '') {
                errors.bot_name = 'Agent name is required';
            }
            if (!data.channel_name) {
                errors.channel_name = "Please select at least one option";
            }
            if (!data.language) {
                errors.language = "Please select at least one option";
            }
            if (!data.language) {
                errors.language = "Please select at least one option";
            }

            if(!data.widget_type){
                errors.widget_type = "Please select one option";
            }
            if(data?.widget_type === 'default_widget'){
                if(!data.widget_url ||  data.widget_url.trim() === ''){
                    errors.widget_url = "Widget url is required";
                }
            }
            if(data?.widget_type === 'custom_hook'){
                if(!data.hook_url || data.hook_url.trim() === ''){
                    errors.hook_url = "Hook url is required";
                }
            }
        }
        // if( step === 'step2'){
        //     if(
        //         !data.others_form_setup ||
        //         data.others_form_setup.length === 0
        //     ){
        //         errors.others_form_setup = errors.others_form_setup || {};
        //         errors.others_form_setup = 'At least one data must be added.';
        //     }
        // }
        if( step === 'step3' ){

            const {
                product_setup,
                features_setup,
                product_features_association,
                product_features_association_data
            } = data;

            const isProductSetupFilled = product_setup && product_setup.length > 0;
            const isFeaturesSetupFilled = features_setup && features_setup.length > 0;
            const isAssociationFilled = product_features_association && Object.keys(product_features_association).length > 0;
            const isAssociationDataFilled = product_features_association_data && product_features_association_data.length > 0;

            const anyFilled = isProductSetupFilled || isFeaturesSetupFilled || isAssociationFilled || isAssociationDataFilled;

            if (anyFilled) {
                if (!isProductSetupFilled) {
                    errors.product_setup = 'At least one product must be added.';
                }
                if (!isFeaturesSetupFilled) {
                    errors.features_setup = 'At least one feature must be added.';
                }
                if (!isAssociationFilled) {
                    errors.product_features_association = 'At least one association must be added.';
                }
                if (!isAssociationDataFilled) {
                    errors.product_features_association_data = 'At least one association data must be added.';
                }
            }


            // if(
            //     !data.product_setup ||
            //     data.product_setup.length === 0
            // ){
            //     errors.product_setup = errors.product_setup || {};
            //     errors.product_setup = 'At least one product must be added.';
            // }

            // if(
            //     !data.features_setup ||
            //     data.features_setup.length === 0
            // ){
            //     errors.features_setup = errors.features_setup || {};
            //     errors.features_setup = 'At least one feature must be added.';
            // }

            // if(
            //     !data.product_features_association ||
            //     Object.keys(data.product_features_association).length === 0
            // ){
            //     errors.product_features_association = errors.product_features_association || {};
            //     errors.product_features_association = 'At least one data must be added.';
            // }

            // if(
            //     !data.product_features_association_data ||
            //     data.product_features_association_data.length === 0
            // ){
            //     errors.product_features_association_data = errors.product_features_association_data || {};
            //     errors.product_features_association_data = 'At least one data must be added.';
            // }

        }
        if( step === 'step4' ){

            const {
                service_setup,
                attribute_setup,
                service_attributes_association,
                service_attributes_association_setup
            } = data;

            const isServiceSetupFilled = service_setup && service_setup.length > 0;
            const isAttributeSetupFilled = attribute_setup && attribute_setup.length > 0;
            const isAssociationFilled = service_attributes_association && Object.keys(service_attributes_association).length > 0;
            const isAssociationDataFilled = service_attributes_association_setup && service_attributes_association_setup.length > 0;

            const anyFilled = isServiceSetupFilled || isAttributeSetupFilled || isAssociationFilled || isAssociationDataFilled;

            if (anyFilled) {

                if (!isServiceSetupFilled) {
                    errors.service_setup = 'At least one service must be added.';
                }
                if (!isAttributeSetupFilled) {
                    errors.attribute_setup = 'At least one attribute must be added.';
                }
                if (!isAssociationFilled) {
                    errors.service_attributes_association = 'At least one service must be added.';
                }
                if (!isAssociationDataFilled) {
                    errors.service_attributes_association_setup = 'At least one association data must be added.';
                }
            }

            // if(
            //     !data.service_setup ||
            //     data.service_setup.length === 0
            // ){
            //     errors.service_setup = errors.service_setup || {};
            //     errors.service_setup = 'At least one service must be added.';
            // }

            // if(
            //     !data.attribute_setup ||
            //     data.attribute_setup.length === 0
            // ){
            //     errors.attribute_setup = errors.attribute_setup || {};
            //     errors.attribute_setup = 'At least one attribute must be added.';
            // }

            // if(
            //     !data.service_attributes_association ||
            //     Object.keys(data.service_attributes_association).length === 0
            // ){
            //     errors.service_attributes_association = errors.service_attributes_association || {};
            //     errors.service_attributes_association = 'At least one service must be added.';
            // }

            // if(
            //     !data.service_attributes_association_setup ||
            //     data.service_attributes_association_setup.length === 0
            // ){
            //     errors.service_attributes_association_setup = errors.service_attributes_association_setup || {};
            //     errors.service_attributes_association_setup = 'At least one service must be added.';
            // }

        }
        // if(step === 'step5'){
        //     if(
        //         !data.final_form_setup ||
        //         data.final_form_setup.length === 0
        //     ){
        //         errors.final_form_setup = errors.final_form_setup || {};
        //         errors.final_form_setup = 'At least one data must be added.';
        //     }
        // }
        return errors;
    };

    // --------- update section ---------- //
    const getUpdateBotData = async () => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        const reqData = {
            bot_id : param_bot_id,
            sass_id: localStorage.getItem('sass_id')
        }
        await axios.post(`${api_base_url}admin/get-bot-details`, reqData, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                if(res.data.data.bot_details.length === 0){
                    toast.error("There is an error");
                    setFormData({
                        bot_id: '',
                        old_bot_name: '',
                        step1: {
                            bot_name: '', 
                            channel_name: null,
                            language: null,
                            bot_description: '',
                            bot_avtar: null,
                            brand_icon: null,
                            bot_welcome_msg: '',
                            widget_type: '',
                            widget_url: '',
                            hook_url: '',
                        },
                        step2: {
                            others_form_setup : [],
                        },
                        step3:{
                            product_setup :[],
                            features_setup : [],
                            product_features_association: {},
                            product_features_association_data: [],
                        },
                        step4:{
                            service_setup : [],
                            attribute_setup : [],
                            service_attributes_association : {},
                            service_attributes_association_setup: []
                        },
                        step5:{
                            final_form_setup: []
                        }
                    });
                    return
                }
                var resData = res.data.data.bot_details[0];
                const {
                    // --- step 1 --- //
                    bot_name,
                    channel_name,
                    language,
                    bot_description,
                    bot_avtar,
                    brand_icon,
                    bot_welcome_msg,
                    bot_hook_type,
                    bot_hook,
                    // ---- step 2 --- //
                    others_form_setup,
                    // ---- step 3 ---- //
                    product_setup,
                    features_setup,
                    product_feature_association_setup,
                    product_feature_association_data,
                    // ---- step 4 ------ //
                    service_setup,
                    attribute_setup,
                    service_attributes_association,
                    service_attributes_association_setup,
                    // --- step 5 ----- //
                    final_form_setup
                } = resData;
                setFormData({
                    bot_id: param_bot_id,
                    old_bot_name: bot_name,
                    step1: {
                        bot_name: bot_name,
                        channel_name: channel_name,
                        language: language,
                        bot_description: bot_description,
                        bot_avtar: bot_avtar,
                        brand_icon: brand_icon,
                        bot_welcome_msg: bot_welcome_msg,
                        widget_type:bot_hook_type,
                        hook_url: bot_hook,
                    },
                    step2: {
                        others_form_setup: others_form_setup,
                    },
                    step3:{
                        product_setup: product_setup,
                        features_setup: features_setup,
                        product_features_association: product_feature_association_setup,
                        product_features_association_data: product_feature_association_data,
                    },
                    step4:{
                        service_setup: service_setup,
                        attribute_setup: attribute_setup,
                        service_attributes_association: service_attributes_association,
                        service_attributes_association_setup: service_attributes_association_setup
                    },
                    step5:{
                        final_form_setup: final_form_setup
                    }
                });
                setPreviousFile({
                    bot_avatar_file:bot_avtar,
                    brand_icon:brand_icon,
                });
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    useEffect(() => {
        if(!param_bot_id){
            setCurrentStep(1); 
            setFormData({
                bot_id: '',
                old_bot_name: '',
                step1: {
                    bot_name: '', 
                    channel_name: null,
                    language: null,
                    bot_description: '',
                    bot_avtar: null,
                    brand_icon: null,
                    widget_type: '',
                    widget_url: '',
                    hook_url: '',
                },
                step2: {
                    others_form_setup : [],
                },
                step3:{
                    product_setup: [],
                    features_setup : [],
                    product_features_association: {},
                    product_features_association_data: [],
                },
                step4:{
                    service_setup : [],
                    attribute_setup : [],
                    service_attributes_association : {},
                    service_attributes_association_setup: []
                },
                step5:{
                    final_form_setup: [],
                }
            });
            return
        }
        else{
            getUpdateBotData()
        }
        
    },[param_bot_id]);

    let step = 1;
    const getStepLs = localStorage.getItem('currentStep')
    if(getStepLs){
        step = parseInt(getStepLs)
    }

    const [currentStep , setCurrentStep] = useState(step);

    const previousStepHandller = () => {
        const prevStep = currentStep - 1;
        setCurrentStep(prevStep)
        setInfoPopupIsOpen(false)
        localStorage.setItem('currentStep', prevStep);
    }
    const [formValidateError, setFormValidateError] = useState({
        step1: {},
        step2: {},
        step3: {},
        step4: {},
        step5: {},
    });

    const [ buttonLoader , setButtonLoader ] = useState(false);

    const nextStepHandller = async () => {
        // setButtonLoader(true)
        const errors = validateStep(`step${currentStep}`);
        if (Object.keys(errors).length > 0) {
            setButtonLoader(false)
            setFormValidateError((prevErrors) => ({
                ...prevErrors,
                [`step${currentStep}`]: errors,
            }));
            return;
        }
        await saveDraft({
            step: `step${currentStep}`,
            data: formData[`step${currentStep}`],
        });

        if(currentStep === 2 || currentStep === 3 || currentStep === 4){
            const nextStepUpdate = currentStep + 1;
            setCurrentStep(nextStepUpdate);
            localStorage.setItem('currentStep', nextStepUpdate);
            setInfoPopupIsOpen(false)
        }
    };

    const finishedHandler = async () => {
        const errors = validateStep(`step${currentStep}`);
        if (Object.keys(errors).length > 0) {
            setButtonLoader(false)
            setFormValidateError((prevErrors) => ({
                ...prevErrors,
                [`step${currentStep}`]: errors,
            }));
            return;
        }

        // ------ api call ------ //
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        const reqData = {
            bot_id : formData.bot_id,
            step : 'final_step',
            sass_id: localStorage.getItem('sass_id'),
            user_type: localStorage.getItem('type'),
            user_name: loginUserType == 'SA' ? localStorage.getItem('system_username') : '',
        }
        await axios.post(`${api_base_url}api/save-bot-details`, reqData, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                await Swal.fire({
                    text: 'Agent successfully created.',
                    icon: 'success',
                    showCancelButton: false,
                    showConfirmButton : true,
                    confirmButtonText: 'OK',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        setFormData({
                            bot_id: '',
                            old_bot_name: '',
                            step1: {
                                bot_name: '', 
                                channel_name: null,
                                language: null,
                                bot_description: '',
                                bot_avtar: null,
                                brand_icon: null,
                                widget_type: '',
                                widget_url: '',
                                hook_url: '',
                            },
                            step2: {
                                others_form_setup : [],
                            },
                            step3:{
                                product_setup: [],
                                features_setup : [],
                                product_features_association: {},
                                product_features_association_data: [],
                            },
                            step4:{
                                service_setup : [],
                                attribute_setup : [],
                                service_attributes_association : {},
                                service_attributes_association_setup: []
                            },
                            step5:{
                                final_form_setup: [],
                            }
                        });
                        loginUserType === 'A' ? navigate("/agents") : navigate('/agents')
                    }
                })
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        });
    }
    const saveDraft = async (stepData) => {

        const { step, data } = stepData;
        if (step !== 'step1' && step !== 'step5') {
            setButtonLoader(false);
            return;
        }
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        } 
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }

        const apiHeaders = {
            headers: {
                'Content-Type': 'multipart/form-data',
                "x-access-token": apiToken
            }
        };
        const createUploadData = (step, data) => {
            let uploadData = new FormData();
            uploadData.append("step", step);
            uploadData.append("bot_id", formData.bot_id);
            uploadData.append("old_bot_name", formData.old_bot_name);
            uploadData.append("sass_id", localStorage.getItem('sass_id'));
            uploadData.append("user_type", localStorage.getItem('type'));
            uploadData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
            if (step === 'step1'){
                uploadData.append("bot_name", data.bot_name);
                uploadData.append("channel_name", JSON.stringify(data.channel_name));
                uploadData.append("language", JSON.stringify(data.language));
                uploadData.append("bot_description", data.bot_description);
                if (data.bot_avtar) uploadData.append("bot_avtar", data.bot_avtar.file);
                if (data.brand_icon) uploadData.append("brand_icon", data.brand_icon.file);

                uploadData.append("widget_type", data.widget_type);
                uploadData.append("widget_url", data.widget_url);
                uploadData.append("hook_url", data.hook_url);

                uploadData.append("old_bot_avatar", JSON.stringify(previousFile.bot_avatar_file));
                uploadData.append("old_brand_icon", JSON.stringify(previousFile.brand_icon));
            }
            return uploadData;
        };
        const makeApiCall = async (uploadData) => {
            try {
                const res = await axios.post(`${api_base_url}api/save-bot-details`, uploadData, apiHeaders);
                if (res.data.status === 'success') {
                    toast.success(res.data.message);
                    setFormData((prevData) => ({
                        ...prevData,
                        bot_id: res.data.data.bot_id,
                        old_bot_name: res.data.data.bot_name
                    }));
                    if(currentStep === 1){
                        setCurrentStep((prevStep) => prevStep + 1);
                    }
                } else if (res.data.status === 'error') {
                    toast.error(res.data.message);
                }

            } catch (error) {
                console.error("Error during save:", error);
                toast.error("An unexpected error occurred while saving.");
            } finally {
                setButtonLoader(false);
            }
        };
        const uploadData = createUploadData(step, data);
        await makeApiCall(uploadData);
    };
    const inputChangeHandler = ( step, fieldName, value, type = 'text' ) => {
        setFormData((prevData) => {
            let newValue = value;
            if (type === 'file') {
                newValue = value.target.files[0];
            }
            if(fieldName === 'bot_name'){
                newValue = specialCharacterValidate(value);
            }
            const updatedFormData = {
                ...prevData,
                [step]: {
                    ...prevData[step],
                    [fieldName]: newValue,
                },
            };
            const fieldError = validateStep(step, updatedFormData[step])?.[fieldName] || '';
            setFormValidateError((prevErrors) => ({
                ...prevErrors,
                [step]: {
                    ...prevErrors[step],
                    [fieldName]: fieldError,
                },
            }));
            return updatedFormData;
        });

        if(fieldName === 'bot_avtar'){
            if(value === null){
                setPreviousFile(prevState => ({
                    ...prevState,
                    bot_avatar_file: {}
                }));
            }
        }
        if(fieldName === 'brand_icon'){
            if(value === null){
                setPreviousFile(prevState => ({
                    ...prevState,
                    brand_icon: {}
                }));
            }
        }
    };

    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization();
        }, 500);
    }, [currentStep]);

    const [ infoPopupIsOpen, setInfoPopupIsOpen ] = useState(false);
    
    const [infoData, setInfoData] = useState({
        title : '',
        info_data: '', 
    });
    const infoPopupCloseOnClick = () => {
        setInfoPopupIsOpen(false)
        setInfoData({
            title : '',
            info_data: '',
        })
    }
    const [scrollbarPosition, setScrollbarPosition] = useState('0')
    const isInfoOpenHandler = (reqData) => {
        setInfoPopupIsOpen(true)
        setInfoData({
            title : reqData.data.title,
            info_data: reqData.data.info,
        })
        const position = window.scrollY || document.documentElement.scrollTop;
        setScrollbarPosition(Math.round(position))
    }

    return (
        <>
            <style>
                {
                    `
                    `
                }
            </style>
            <PageTitle breadcrumbs={pageTitle}>
                Manage Agent
            </PageTitle>
            <div className='row'>
                <div className={`col-md-${infoPopupIsOpen ? '9' : '12'}`}>
                    <div className="card card-flush border" id="user_add_card">
                        <div className="card-header py-3">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800 fs-2">
                                    {
                                        param_bot_id ? `Edit Agent ${formData.step1.bot_name}` : 
                                        'Start Creating Agent'
                                    }
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Step {currentStep}
                                </span>
                            </h3>
                        </div>
                        <div className={`card-body pt-0`}>
                            { currentStep === 1 &&
                                <Step1
                                    onInputChange={inputChangeHandler} 
                                    formValidateError={formValidateError}
                                    formData={formData}
                                />
                            }
                            { currentStep === 2 &&
                                <Step2
                                    onInputChange={inputChangeHandler}
                                    formValidateError={formValidateError[`step${currentStep}`]}
                                    formData={{
                                        ...formData,
                                        bot_id: formData.bot_id,
                                    }}
                                    isInfoOpenHandler={isInfoOpenHandler}
                                /> 
                            }
                            { currentStep === 3 &&
                                <Step3
                                    onInputChange={inputChangeHandler}
                                    formValidateError={formValidateError[`step${currentStep}`]}
                                    formData={{
                                        ...formData,
                                        bot_id: formData.bot_id,
                                    }}
                                    isInfoOpenHandler={isInfoOpenHandler}
                                />
                            }
                            { currentStep === 4 &&
                                <Step4
                                    onInputChange={inputChangeHandler}
                                    formValidateError={formValidateError[`step${currentStep}`]}
                                    formData={{
                                        ...formData,
                                        bot_id: formData.bot_id,
                                    }}
                                    isInfoOpenHandler={isInfoOpenHandler}
                                />
                            }
                            { currentStep === 5 &&
                                <Step5
                                    onInputChange={inputChangeHandler}
                                    formValidateError={formValidateError[`step${currentStep}`]}
                                    formData={{
                                        ...formData,
                                        bot_id: formData.bot_id,
                                    }}
                                    isInfoOpenHandler={isInfoOpenHandler}
                                />
                            }
                            <div className='row mt-3'>
                                <div className="col-md-12 text-end">
                                    {currentStep > 1 && (
                                        <a
                                            href="#" 
                                            className="btn btn-danger me-4" 
                                            onClick={(e) => { e.preventDefault(); previousStepHandller()}}
                                        >
                                            Previous
                                        </a>
                                    )}
                                    {currentStep < 5 && (
                                        <a
                                            href="#" 
                                            className={`btn btn-primary ${buttonLoader && 'disabled'}`}
                                            onClick={(e) => { e.preventDefault(); nextStepHandller()}}
                                        >
                                            {
                                                buttonLoader ? 
                                                <ButtonLoader btnHtml='Please wait...' className='me-2'/>
                                                :
                                                'Next'
                                            }
                                        </a>
                                    )}
                                    {currentStep === 5 && (
                                        <a
                                            href="#" 
                                            className="btn btn-dark"
                                            onClick={(e) => { e.preventDefault(); finishedHandler()}}
                                        >
                                            Finished
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    infoPopupIsOpen && 
                    <div className='col-md-3'>
                        <div className="card bg-light" style={{ position: 'sticky', top: '90px',overflow: 'auto',height: '80vh', maxHeight: 'fit-content'}}>
                            <div className="card-body pb-0">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="d-flex align-items-center flex-grow-1">
                                        <div className="d-flex flex-column">
                                            <div className="text-gray-900 fs-5 fw-bold">
                                                {infoData.title}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="my-0">
                                        <FontAwesomeIcon 
                                            icon={faXmark} 
                                            className='fs-2 cursor-pointer' 
                                            onClick={infoPopupCloseOnClick}
                                        />
                                    </div>
                                </div>
                                <div className="mb-5">
                                    <p className="text-gray-600 fs-5">
                                        {infoData.info_data}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default ManageVirtualAgent